import { useContext } from 'react';
import LibraryContext from 'business/organizer/library/contexts/library/LibraryContext';

export default function useLibrary(): ILibraryContext {
  return useContext(LibraryContext) as ILibraryContext;
}
